export default __webpack_public_path__ + "static/media/prizes-header.ada8de40.jpg";